import { render } from "./MarkdownRenderer.vue?vue&type=template&id=05af2a90&ts=true"
import script from "./MarkdownRenderer.vue?vue&type=script&lang=ts"
export * from "./MarkdownRenderer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__